import { useAuthIsLoaded } from '@/hooks/useAuthIsLoaded';
import { useGetAdvisorGroupSettingsQuery } from '@/store/settingsApi';
import AdvisorGroupSettings from '@/utils/advisorGroupSettings.utility';

/** Whether the advisor group's `ShowAllTransactionsInCashFlow` setting is enabled. */
export const useShowAllInCashFlow = () => {
  const isAuthLoaded = useAuthIsLoaded();
  const { data: advisorGroupSettings } = useGetAdvisorGroupSettingsQuery(
    undefined,
    { skip: !isAuthLoaded },
  );

  return AdvisorGroupSettings(advisorGroupSettings).getByKey(
    'ShowAllTransactionsInCashFlow',
  );
};
